angular.module('cfn').factory('cfnGridPrinting', function() {
  var service = {};

  service.init = function(scope, element, attrs) {
    var serviceInstance = {};
    scope.print = function() {
      if (scope.printable == 'true') {
        app.showLoader();
        scope.calculateWidths(940);
        $('.printableContent', element).append(scope.$$printableContent);

        ang.callAfter(function() {
          ang.callAfter(function() {
            $('.printFrame', element).attr('src', 'print.html');

            var html = ''; // "<h3>Arne test</h3>"; TODO: do we want a header?

            html += $('.printableContent', element).html();
            console.debug('html', html);

            $('.printFrame', element).load(function() {
              $('.printFrame', element)
                .contents()
                .find('body')
                .html(html);
              $('.printFrame', element)[0].contentWindow.focus(); // for ie we have to focus the iframe before
              $('.printFrame', element)[0].contentWindow.print();
            });

            app.hideLoader();
            scope.calculateWidths(scope.width);
            $('.printableContent', element).html('');
          });
        }, scope);
      }
    };
    return serviceInstance;
  };

  return service;
});
